module.exports = __webpack_public_path__ + "static/media/psd1.40ea7ef9.png";